import {
  ENV_ENVIRONMENT,
  DEVELOPMENT,
  ENV_BACK_END_URL,  
  ENV_RECAPTCHA_SITE,
  ENV_API_KEY_TELEFONO,
} from "./constants";

const ENVIRONMENT = process.env[ENV_ENVIRONMENT];

function isDevelopment() {
  return ENVIRONMENT === DEVELOPMENT;
}

const BACK_END_URL = process.env[ENV_BACK_END_URL] || "http://localhost:3000";
const RECAPTCHA_SITE = process.env[ENV_RECAPTCHA_SITE];
const API_KEY_TELEFONO = process.env[ENV_API_KEY_TELEFONO];

export { ENVIRONMENT, BACK_END_URL, RECAPTCHA_SITE, API_KEY_TELEFONO, isDevelopment };
